(($) => {
    const form = $('.tpfl-form ');
    const dropZone = $('.file-dropzone');
    const fileInput = $('#fileInputUpload');
    let removeFile = '';
    let selectedFiles = [];

    function addDragAndDropHandlers() {
        dropZone.on('dragover', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).addClass('dragging');
        });

        dropZone.on('dragleave', function(e) {
            $(this).removeClass('dragging');
        });
    }

    function handleFileSelection(files) {
        // loop through files and add to dropzone
        for (let i = 0; i < files.length; i++) {
            dropZone.after(`<p>${files[i].name} <button type="button" id="removeFile" data-file="${i}" class="removeFile text-sm">Remove</button></p>`);
        }   
        addRemoveFileHandler();
    }

    function addRemoveFileHandler() {
        removeFile = $('.removeFile');
        removeFile.on('click', (e) => {
            e.preventDefault();
            const remove = window.confirm('Are you sure you want to remove this file?');
            if (remove) {
                const fileIndex = $(e.target).data('file');
                $(e.target).parent().remove();
                selectedFiles = selectedFiles.filter((file, index) => index !== fileIndex);
                fileInput.prop('files', selectedFiles);
            }
        });
    }

    function addDropHandler() {
        dropZone.on('drop', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).removeClass('dragging');
            var files = e.originalEvent.dataTransfer.files;
            selectedFiles = files;
            fileInput.prop('files', selectedFiles);
            handleFileSelection(files);
        });
    }

    let file_input_clicked = 0;

    function addClickHandler() {
        if (dropZone) {
            dropZone.on('click', (e) => {
                e.stopPropagation();
                if(e.target.id !== 'fileUpload') {
                    e.preventDefault();
                    fileInput.trigger('click');
                    addFileUploadChangeHandler();
                }
            });
        }
    }

    function addFileUploadChangeHandler() {
        fileInput.off('change').on('change', function() {
            var files = $(this).prop('files');
            var size = files[0].size / 1024 / 1024;
            if (size > 10) {
                alert('File size must be less than 10MB');
                return;
            }
            handleFileSelection(files);
        });
    }

    if ( form ) {
        form.on('submit', function(e) {
            e.preventDefault();
            const submitButton = form.find('[name="sf-submit"]');
            submitButton.prop('disabled', true);
            submitButton.val('Submitting...');
            submitButton.text('Submitting...');
            this.submit();
        });
    }

    // Initialize handlers
    addDragAndDropHandlers();
    addDropHandler();
    addClickHandler();
})(jQuery);